document.addEventListener('DOMContentLoaded', () => {

  // DETECT PAGE LANGUAGE
  const pageLang = document.documentElement.lang || 'pl';

  const messages = {
    pl: 'Wprowadź poprawny e-mail.',
    en: 'Enter a valid e-mail.'
  };

  //EMAIL VALIDATION LOGIN
  const newsletterInput = document.getElementById('NewsletterForm--footer');
  const newsletterError = document.getElementById('newsletter-error');
  const newsletterButton = document.querySelector('.newsletter-form__button');
  
  newsletterInput.addEventListener('focus', () => {
    const emailValue = newsletterInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
      newsletterError.textContent = messages[pageLang] || messages['pl'];
      newsletterInput.classList.add('error-border');
      newsletterButton.disabled = true;
    } else {
      newsletterError.textContent = '';
      newsletterInput.classList.remove('error-border');
      newsletterButton.disabled = false;
    }
  });

  newsletterInput.addEventListener('input', () => {
    const emailValue = newsletterInput.value.trim();
    if (emailValue === '' || !isValidEmail(emailValue)) {
      if (!newsletterInput.classList.contains('error-border')) {
        newsletterInput.classList.add('error-border');
      }
      newsletterError.textContent = messages[pageLang] || messages['pl'];
      newsletterButton.disabled = true;
    } else {
      newsletterError.textContent = '';
      newsletterInput.classList.remove('error-border');
      newsletterButton.disabled = false;
    }
  });
  
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
});